/** Builds a chronologically sorted task list for calendar keyboard roving. */
import { format } from 'date-fns';

const ISO_DATE_PREFIX_LENGTH = 10;

const toDateKey = (task) => {
  if (!task?.date) return '';
  if (task.date.toDate) return format(task.date.toDate(), 'yyyy-MM-dd');
  if (typeof task.date === 'string') return task.date.slice(0, ISO_DATE_PREFIX_LENGTH);
  return format(task.date, 'yyyy-MM-dd');
};

/**
 * @param {import('@/types').Task[] | undefined} filteredTasks
 * @param {{ date: Date }[]} days
 */
export function buildCalendarNavigableTasks(filteredTasks, days) {
  if (!filteredTasks?.length || !days?.length) return [];

  const visibleDays = new Set(days.map((day) => format(day.date, 'yyyy-MM-dd')));

  return filteredTasks
    .filter(
      (task) =>
        !task.isNew && task.id && task.date && visibleDays.has(toDateKey(task)),
    )
    .sort((left, right) => {
      const dateCmp = toDateKey(left).localeCompare(toDateKey(right));
      if (dateCmp !== 0) return dateCmp;
      return (left.time || '00:00').localeCompare(right.time || '00:00');
    });
}
